import Qty from "@/core/types/Qty";
import ProductionSite from "@/domains/ProductionSites/ProductionSite";
import DateSimple from "@/core/types/DateSimple";
import Serializable from "@/core/misc/mixins/Serializable";
import Core from "@/core/Core";
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";
import BaseEntity from "@/core/misc/BaseEntity";

export default class ProductionPlanProduct extends BaseEntity {

  /* Код продукта */
  public code: string;

  @Title_ru_RU('Количество', TYPES.STRING)
  public qty: Qty|null;

  /* Дата изменения */
  public dataModificationDate: Date|null;

  /* Наименование продукта */
  public name: string|null;

  /* Производственная площадка */
  public productionSite: ProductionSite|null;

  /* Эта штука нужна, чтобы показывать количество у каждого продукта по месяцам
  * Пример: Продукт №1 с произвольным названием,
  * qtyByDates: {'2026-04-01':
  * {
  * id: Идентификатор ЗАПИСИ на месяц даты 2026-04-01,
  * qty: Количество на месяц даты 2026-04-01,
  * plannedArrivalDate: Дублирование ключа, чтобы лишний раз не возиться с ключом, Это дата планируемого прибытия,
  * SWOracleDocumentId: Номер документа в оракле
  * }
  * }
  * */
  public qtyByDates: Record<string, { SWOracleDocumentId: number, id: number, plannedArrivalDate: DateSimple, qty: Qty }>[]|null;

  public static fromServer(data: any, result = new ProductionPlanProduct()): ProductionPlanProduct {
    super.fromServer(data, result);
    result.code = data.code;
    result.qty = data?.qty ? Qty.fromServer(data.qty) : null;
    result.dataModificationDate = data?.dataModificationDate ? new Date(data.dataModificationDate) : null;
    result.id = data?.id ?? null;
    result.name = data?.name ?? null;
    result.productionSite = data?.productionSite !== null ? Core.utils.hydrate(data.productionSite, ProductionSite.fromServer) : null;

    /* Чтобы гидрировать qty и plannedArrivalDate, сохранив структуру */
    result.qtyByDates = data?.qtyByDates
      ? Object.fromEntries(
        Object.entries(data.qtyByDates).map(([key, value]: [string, any]) => {
          return [
            key,
            {
              SWOracleDocumentId: value.SWOracleDocumentId,
              id: value.id,
              plannedArrivalDate: DateSimple.fromServer(value.plannedArrivalDate),
              qty: Qty.fromServer(value.qty)
            }
          ];
        })
      )
      : null;

    return result;
  }

}
